import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { Page } from "types/dto/Page";
import { toast } from "react-hot-toast";
import { RegistroTabelaCondominioGroupPay } from "types/groupPay/RegistroTabelaCondominioGroupPay";
import { RequestCondominiosPaginados } from "types/request/RequestCondominiosPaginados";

export const useGetRegistrosTabelaCondominioGroupPay = (request: RequestCondominiosPaginados) => {
  const onError = () => {
    toast.error("Erro ao buscar condomínios");
  };

  const config = {
    staleTime: 1000 * 60 * 5,
    retry: 5,
  };

  return useFetch<Page<RegistroTabelaCondominioGroupPay>>({
    key: [
      "tabela-condominios-group-pay",
      request.sort,
      request.page,
      request.nomeCondominio,
      request.size,
      request.sort,
    ],
    url: api.condominio.getRegistrosTabelaCondominioGroupPay,
    params: request,
    enabled: true,
    config,
    onError,
  });
};
